// These should match the Tailwind/Zin UI breakpoints
export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1920,
} as const

// Convert pixels to rems for Tailwind config
export const breakpointScreens = Object.entries(breakpoints).reduce(
  (acc, [key, value]) => ({
    ...acc,
    [key]: `${value}px`,
  }),
  {} as Record<keyof typeof breakpoints, string>,
)

export type Breakpoint = keyof typeof breakpoints
